import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const AccordionTitle = styled(Typography, { skipSx: false })(
  ({ theme }) => ({
    '&.MuiTypography-root': {
      fontSize: '16px',
      textTransform: 'uppercase',
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
  }),
);
